/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface VehicleModelOptionDto
 */
export interface VehicleModelOptionDto {
    /**
     *
     * @type {string}
     * @memberof VehicleModelOptionDto
     */
    model?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleModelOptionDto
     */
    vehicleType?: VehicleModelOptionDtoVehicleTypeEnum;
    /**
     *
     * @type {number}
     * @memberof VehicleModelOptionDto
     */
    batteryCapacityKwh?: number;
}

/**
 * @export
 */
export const VehicleModelOptionDtoVehicleTypeEnum = {
    Unknown: "Unknown",
    Bev: "BEV",
    Phev: "PHEV",
    Fcev: "FCEV",
} as const;
export type VehicleModelOptionDtoVehicleTypeEnum =
    (typeof VehicleModelOptionDtoVehicleTypeEnum)[keyof typeof VehicleModelOptionDtoVehicleTypeEnum];

/**
 * Check if a given object implements the VehicleModelOptionDto interface.
 */
export function instanceOfVehicleModelOptionDto(
    value: object,
): value is VehicleModelOptionDto {
    return true;
}

export function VehicleModelOptionDtoFromJSON(
    json: any,
): VehicleModelOptionDto {
    return VehicleModelOptionDtoFromJSONTyped(json, false);
}

export function VehicleModelOptionDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): VehicleModelOptionDto {
    if (json == null) {
        return json;
    }
    return {
        model: json["model"] == null ? undefined : json["model"],
        vehicleType:
            json["vehicleType"] == null ? undefined : json["vehicleType"],
        batteryCapacityKwh:
            json["batteryCapacityKwh"] == null
                ? undefined
                : json["batteryCapacityKwh"],
    };
}

export function VehicleModelOptionDtoToJSON(
    value?: VehicleModelOptionDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        model: value["model"],
        vehicleType: value["vehicleType"],
        batteryCapacityKwh: value["batteryCapacityKwh"],
    };
}
